import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{staticClass:"dialog",attrs:{"persistent":"","max-width":"500"},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c(VCard,{staticClass:"model-card text-center dialog",attrs:{"color":'#15181E'}},[_c('div',{class:'header title'},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"sub-title"},[_vm._v(" "+_vm._s(_vm.message)+" ")]),_c('div',{class:_vm.status ? 'status-success' : 'status-fail'},[_c('img',{staticClass:"image",attrs:{"src":_vm.status
            ? require('../../assets/gif/check.gif')
            : require('../../assets/gif/error.gif')}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }